'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBodyClassname = require('react-body-classname');

var _reactBodyClassname2 = _interopRequireDefault(_reactBodyClassname);

var _events = require('redux/modules/events');

var _components = require('../components');

var _connectData = require('helpers/connectData');

var _connectData2 = _interopRequireDefault(_connectData);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchData(getState, dispatch, location) {
  var promises = [];

  if (location.query.range) {
    var range = location.query.range.split(',').map(function (time) {
      return (0, _moment2.default)(time);
    });

    if (range.length) {
      var start = range[0] ? range[0].format('YYYY-MM-DD HH:mm:ss') : null;
      var end = range[1] ? range[1].format('YYYY-MM-DD HH:mm:ss') : null;
      promises.push(dispatch((0, _events.selectRange)({ start: start, end: end })));
    }
  }

  var withRecurrences = getState().events.recurrences;

  // force reload events with back and next browser buttons
  promises.push(dispatch((0, _events.index)(location.search === '' ? '?order=start_date&recurrences=' + withRecurrences : location.search + '&order=start_date&recurrences=' + withRecurrences)));

  return _promise2.default.all(promises);
}

var EventsContainer = (_dec = (0, _connectData2.default)(fetchData), _dec(_class = function (_Component) {
  (0, _inherits3.default)(EventsContainer, _Component);

  function EventsContainer() {
    (0, _classCallCheck3.default)(this, EventsContainer);
    return (0, _possibleConstructorReturn3.default)(this, (EventsContainer.__proto__ || (0, _getPrototypeOf2.default)(EventsContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(EventsContainer, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactBodyClassname2.default,
        { className: 'events' },
        _react2.default.createElement(_components.Events, null)
      );
    }
  }]);
  return EventsContainer;
}(_react.Component)) || _class);
exports.default = EventsContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/EventsContainer.js
// module id = 1154
// module chunks = 0